import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const setTokens = (d) => {
  localStorage.setItem("s7_at", d.access_token);
  localStorage.setItem("s7_rt", d.refresh_token);
};
export const clearTokens = () => {
  localStorage.removeItem("s7_at");
  localStorage.removeItem("s7_rt");
};

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("s7_at");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const o = err.config || {};
    if (err.response?.status === 401 && !o._retry && localStorage.getItem("s7_rt") && !String(o.url).includes("/auth/login")) {
      o._retry = true;
      refreshing =
        refreshing ||
        axios
          .post(`${API}/auth/refresh`, { refresh_token: localStorage.getItem("s7_rt") })
          .then((r) => setTokens(r.data))
          .finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(o);
      } catch {
        clearTokens();
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Your draft is still here — try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ").replace("Value error, ", "");
  return fallback;
}

export async function openFile(path) {
  const w = window.open("", "_blank");
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  if (w) w.location = url;
  else window.location = url;
}

export const money = (n) => (n == null || n === "" ? "—" : `$${Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 })}`);
export const fmtDate = (s, opts = { month: "short", day: "numeric", year: "numeric" }) => {
  if (!s) return "—";
  const d = s.length <= 10 ? new Date(s + "T12:00:00") : new Date(s);
  return d.toLocaleDateString("en-US", opts);
};
export const fmtTime = (s) => (s ? new Date(s).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "");

// ---------- first-party analytics ----------
const consentDeclined = () => localStorage.getItem("s7_cookie") === "declined";
export function sessionId() {
  let s = localStorage.getItem("s7_sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("s7_sid", s);
  }
  return s;
}
export function captureSource() {
  if (sessionStorage.getItem("s7_src")) return;
  const q = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => q.get(k) && (utm[k] = q.get(k)));
  let src = utm.utm_source || "";
  if (!src && document.referrer) {
    try {
      const h = new URL(document.referrer).hostname;
      if (!h.includes(window.location.hostname)) src = h.includes("tiktok") ? "tiktok" : h.includes("google") ? "google" : h;
    } catch { /* ignore */ }
  }
  sessionStorage.setItem("s7_src", JSON.stringify({ source: src || "direct", utm }));
}
export function getRefCode() {
  const m = document.cookie.match(/(?:^|; )s7_ref=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
}
export function track(type, extra = {}) {
  if (consentDeclined()) return;
  const src = JSON.parse(sessionStorage.getItem("s7_src") || "{}");
  axios.post(`${API}/track`, { sessionId: sessionId(), type, path: window.location.pathname, source: src.source || "", utm: src.utm || {}, referralCode: getRefCode(), ...extra }).catch(() => {});
}
